import EventActionProto from '../event-action-proto';
import MyWorkCollection from 'core/gd-model/my-work/my-work-collection';

module.exports = class EventMyWorkReset extends EventActionProto {

    constructor(uid, data) {
        super(uid, data);
    }

    validate() {
        return true;
    }

    process() {
        if (!gd.session.myWork) gd.session.myWork = new MyWorkCollection();

        gd.session.myWork.validateAndReset(this.data,{parse:true});
        gd.bus.triggerEvent('gd.session.myWork:reset');
    }
};